<template>
  <div>
    <CreateNavBar/>
	  <div class="nav-container">
	    <nav class="navbar sticky-top">
	    </nav>
	  </div>

    <div class="text-center">
      <img :src="image" width="50%">
      <h3>Yikes!</h3>
      <h5>It seems like you're lost!</h5>
      <br>
      <p>Return to previous page.</p>
      <br>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { IMAGE_404 } from '@/api/constants/ImageAssets'
import CreateNavBar from '@/components/common/CreateNavBar'
import Footer from '@/components/common/Footer'

export default {
  components: {
    CreateNavBar,
    Footer
  },
  data() {
    return {
      image: IMAGE_404
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/containers/Page404.vue